import { Checkbox, Tooltip } from "antd";
import { useState } from "react";
import styles from "./style.module.scss";
interface SelectOptionProps {
  selectedValues: string[];
  label: string;
  value: string;
}
export const SelectOption = ({
  selectedValues,
  label,
  value,
}: SelectOptionProps) => {
  const [isEllipsed, setIsEllipsed] = useState(false);

  const setRef = (node: HTMLSpanElement | null) => {
    if (!node) return;
    setIsEllipsed(node.scrollWidth > node.offsetWidth);
    if (node.hasAttribute("title")) node.removeAttribute("title");
  };

  return (
    <div className={styles.option}>
      <Checkbox checked={selectedValues.includes(value)} />
      {isEllipsed ? (
        <Tooltip placement="right" title={label}>
          <span ref={setRef} className={styles.label}>
            {label}
          </span>
        </Tooltip>
      ) : (
        <span ref={setRef} className={styles.label}>
          {label}
        </span>
      )}
    </div>
  );
};
